<template>
  <div>
    <div style="cursor: pointer;padding: 16px 16px 0;display: inline-block;"
         @click="$router.go(-1)">
      <i class="el-icon-back">返回</i>
    </div>
  </div>
</template>

<script>
export default {
  //import引入组件才能使用
  components: {},
  props: {},
  data () {
    return {

    };
  },
  // 计算属性
  computed: {},
  // 监听data中的数据变化
  watch: {},
  // 生命周期：挂载完成时（可以访问DOM元素）
  mounted () {

  },
  // 方法集合
  methods: {

  },
}
</script>
<style scoped>
</style>